import { Box, Container, Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import Image from 'src/common/components/Image';
import Page from 'src/common/components/Page';
import { default as useMessage } from 'src/common/hooks/useMessage';
import useResponsive from 'src/common/hooks/useResponsive';
import vn from '../../common/locales/vn';
import { dispatch } from '../../common/redux/store';
import { CONFIG_APP_DETAIL } from '../../config';
import LoginForm from './component/LoginForm';
import { isExpiredSelector, setIsExpired } from './login.slice';
import { useTranslation } from 'react-i18next';

const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const SectionStyle = styled(Box)(({ theme }) => ({
  width: '100%',
  maxWidth: '646px',
  display: 'flex',
  justifyContent: 'center',
  margin: theme.spacing(2, 0, 2, 2),
  padding: '0!important',
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

export default function Login() {
  const mdUp = useResponsive('up', 'md');
  const { showErrorSnackbar } = useMessage();
  const { t } = useTranslation();

  const expired = useSelector(isExpiredSelector);

  useEffect(() => {
    if (expired) {
      showErrorSnackbar(t('expired'));
      dispatch(setIsExpired(false));
    }
  }, [expired]);

  return (
    <Page
      title="Login"
      sx={{
        width: '100%',
        background: 'var(--bg-color)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 'fix-content',
      }}
    >
      <RootStyle
        sx={{
          width: '80%',
          minHeight: '500px',
          margin: '10vh 0px',
          height: '80vh',
          boxShadow:
            'rgba(0, 0, 0, 0.25) 0px 14px 28px, rgba(0, 0, 0, 0.22) 0px 10px 10px',
          borderRadius: '20px',
          background: '#fff',
        }}
      >
        {mdUp && (
          <SectionStyle>
            <Image
              visibleByDefault
              disabledEffect
              src="/images/login-wallpaper.jpg"
              alt="login"
            />
          </SectionStyle>
        )}

        <Container maxWidth="sm">
          <ContentStyle>
            <Stack
              direction="row"
              display="flex"
              alignItems="center"
              sx={{
                mb: 5,
              }}
            >
              <Stack
                direction="row"
                spacing={1}
                sx={{ flexGrow: 1, justifyItems: 'space-between' }}
              >
                <Typography variant="h4" gutterBottom>
                  {t('welcome')}
                </Typography>
                <Typography color={'var(--main-color)'} variant="h4">
                  {CONFIG_APP_DETAIL?.name}
                </Typography>
              </Stack>
            </Stack>
            <LoginForm />
          </ContentStyle>
        </Container>
      </RootStyle>
    </Page>
  );
}
